import { useTranslation } from 'react-i18next';

import { LuMoon, LuSun } from 'react-icons/lu';

import { Theme, useTheme } from '../../../../context/ThemeContext';
import { SidebarRailTooltip } from '../../../SidebarRailTooltip/SidebarRailTooltip';

interface ThemeToggleProps {
  isOpen: boolean;
}

const THEME_ICONS = {
  [Theme.LIGHT]: LuSun,
  [Theme.DARK]: LuMoon,
} as const;

const THEME_LABELS = {
  [Theme.LIGHT]: 'common.theme_light',
  [Theme.DARK]: 'common.theme_dark',
} as const;

const stylesheet = {
  container: 'flex flex-col mb-4',
  button:
    'flex items-center p-2 rounded-semantic hover:bg-semantic-bg-hover cursor-pointer text-semantic-text-primary',
  buttonCollapsed: 'justify-center',
  iconSlot: 'flex-shrink-0',
  text: 'ml-3 text-left text-sm whitespace-nowrap overflow-hidden',
};

export function ThemeToggle({ isOpen }: Readonly<ThemeToggleProps>) {
  const { t } = useTranslation();
  const { theme, toggleTheme } = useTheme();

  const Icon = THEME_ICONS[theme];

  const button = (
    <button
      type="button"
      className={`${stylesheet.button} ${isOpen ? '' : stylesheet.buttonCollapsed}`}
      onClick={toggleTheme}
      aria-label={t('common.theme_label')}
    >
      <Icon className={stylesheet.iconSlot} />
      {isOpen && (
        <span className={stylesheet.text}>
          {t('common.theme_label')}: {t(THEME_LABELS[theme])}
        </span>
      )}
    </button>
  );

  return (
    <div className={stylesheet.container}>
      {isOpen ? (
        button
      ) : (
        <SidebarRailTooltip label={t('common.theme_label')}>
          {button}
        </SidebarRailTooltip>
      )}
    </div>
  );
}
